import * as React from 'react';
const IconCheckboxChack = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
  >
    <path
      fill="#396DFF"
      d="M4.167 0A4.167 4.167 0 0 0 0 4.167v11.666A4.167 4.167 0 0 0 4.167 20h11.666A4.167 4.167 0 0 0 20 15.833V4.167A4.167 4.167 0 0 0 15.833 0H4.167Zm10.59 8.09-5.834 5.833a.833.833 0 0 1-1.18 0l-2.5-2.5A.833.833 0 0 1 5.833 10a.833.833 0 0 1 .59.244l1.91 1.912 5.244-5.245a.834.834 0 1 1 1.18 1.18Z"
    />
  </svg>
);
export default IconCheckboxChack;
